import { render, staticRenderFns } from "./SubscriptionProductsList.vue?vue&type=template&id=8b0d6e40&"
import script from "./SubscriptionProductsList.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionProductsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports